<template>
  <div
    class="container"
    :class="containerClasses"
  >
    <StSidebar
      :temporary="false"
      @sidebar-changed="sideBarChanged"
    >
      <template #items>
        <v-list
          dense
          class="pt-0"
        >
          <router-link :to="{ name: 'access'}">
            <v-list-item>
              <v-list-item-icon>
                <StIcon icon-name="login" />
              </v-list-item-icon>
              <v-list-item-title>
                {{ $t('LayoutContent.label.router.access') }}
              </v-list-item-title>
            </v-list-item>
          </router-link>
          <router-link :to="{ name: 'universes'}">
            <v-list-item>
              <v-list-item-icon>
                <StIcon icon-name="view-dashboard-outline" />
              </v-list-item-icon>
              <v-list-item-title>
                {{ $t('LayoutContent.label.router.dashboard') }}
              </v-list-item-title>
            </v-list-item>
          </router-link>
        </v-list>
      </template>
    </StSidebar>

    <v-row
      class="layout-content no-gutters"
    >
      <transition name="fade">
        <router-view />
      </transition>
    </v-row>
  </div>
</template>

<script>
import StSidebar from '@stilingue/st-sidebar';
import StIcon from '@stilingue/st-icon';

export default {
  name: 'LayoutContent',
  components: {
    StSidebar,
    StIcon,
  },
  data() {
    return {
      expandContainer: true
    };
  },
  computed: {
    containerClasses() {
      return {
        'container--expanded': this.expandContainer
      };
    }
  },
  methods: {
    sideBarChanged({ mini }) {
      this.expandContainer = !mini;
    }
  }
};
</script>

<style lang="scss" scoped>
  .fade-enter-active,
  .fade-leave-active {
    transition-duration: 0.2s;
    transition-property: opacity;
    transition-timing-function: ease-in-out;
  }

  .fade-enter,
  .fade-leave-active {
    opacity: 0;
  }

  .container {
    width: 100vw;
    max-width: 100vw;
    padding: 0 0 0 93px;
    margin: 0;
    -webkit-transition: padding 0.2s cubic-bezier(0.4, 0, 0.2, 1);
    -moz-transition: padding 0.2s cubic-bezier(0.4, 0, 0.2, 1);
    -o-transition: padding 0.2s cubic-bezier(0.4, 0, 0.2, 1);
    transition: padding 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  }

  .container--expanded {
    padding-left: 253px;
  }

  .layout-content {
    height: calc(100vh - 58px);
    width: 100%;
    overflow: auto;
  }

  ::v-deep {
    .ds-icon {
      background-color: var(--ds-color-text-neutral);
    }
  }
</style>
